import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { userIsNotAuthenticatedRedir, userIsAdminRedir } from './config/auth';
import Loading from './components/loading/Loading';

const DefaultLayout = React.lazy(() => import('./containers/layout/Layout'));
const ResetPassword = React.lazy(() => import("./containers/auth/reset-password/ResetPassword"));
const Beranda = React.lazy(() => import('./containers/beranda/Beranda'));

const Home = userIsAdminRedir(DefaultLayout);
const Sign = Beranda;

const loading = () => <Loading />

class App extends React.Component {
    render() {
        return (
            <React.Fragment>
                <BrowserRouter>
                    <React.Suspense fallback={loading()}>
                        <Switch>
                            <Route exact path="/beranda" name="Login Page" label="Login Page" render={(props) => <Sign {...props} />} />
                            <Route exact path="/auth/reset-password" name="Reset Password" label="Reset Password" component={ResetPassword} />
                            <Route path="/" name="Home" render={(props) => <Home {...props} />}></Route>
                        </Switch>
                    </React.Suspense>
                </BrowserRouter>
            </React.Fragment>
        )
    }
}

export default App;
